import { render, staticRenderFns } from "./CompetenciesList.vue?vue&type=template&id=246ff3dc&scoped=true"
import script from "./CompetenciesList.vue?vue&type=script&lang=js"
export * from "./CompetenciesList.vue?vue&type=script&lang=js"
import style0 from "./CompetenciesList.vue?vue&type=style&index=0&id=246ff3dc&prod&lang=scss"
import style1 from "./CompetenciesList.vue?vue&type=style&index=1&id=246ff3dc&prod&lang=scss&scoped=true"
import style2 from "./CompetenciesList.vue?vue&type=style&index=2&id=246ff3dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246ff3dc",
  null
  
)

export default component.exports